import { render } from "./myQuo.vue?vue&type=template&id=64bb4811&scoped=true"
import script from "./myQuo.vue?vue&type=script&lang=js"
export * from "./myQuo.vue?vue&type=script&lang=js"

import "./myQuo.vue?vue&type=style&index=0&id=64bb4811&lang=scss"
import "./myQuo.vue?vue&type=style&index=1&id=64bb4811&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb4811"]])

export default __exports__